module.exports = __webpack_public_path__ + "static/papyr-dbe8416e087e16bf4fc8e43a697657ee.png";